var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "rt-select-control": true,
        "floating-select": _vm.type === "floating",
        selected: _vm.selectedValue,
      },
    },
    [
      _c(
        "select",
        {
          ref: "select",
          staticClass: "rt-select__field",
          attrs: {
            name: _vm.name,
            disabled: _vm.disabled,
            autofocus: _vm.autofocus,
          },
          on: { change: _vm.onChangeSelect },
        },
        _vm._l(_vm.options, function (optionValue, idx) {
          return _c(
            "option",
            {
              key: idx,
              domProps: { value: idx, selected: _vm.selectedValue === idx },
            },
            [_vm._v(_vm._s(optionValue))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.type === "floating" && _vm.selectedValue
        ? _c(
            "div",
            {
              staticClass: "rt-select__floating-control-wrapper",
              on: { click: _vm.focus },
            },
            [
              _c("div", { staticClass: "floating-placeholder" }, [
                _vm._v(_vm._s(_vm.getFloatingLabel())),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "floating-select-info" }, [
                _vm._v(_vm._s(_vm.getSelectedInfo())),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }